export default "__VITE_ASSET__82550c69__"